import { Response } from '@marketplace-web/core-api/api-client-util'
import { transformCurrencyAmountDto } from '@marketplace-web/currency/currency-data'

import {
  ClosetPromotionModel,
  ClosetPromotionMotivationModel,
  ClosetPromotionOrderModel,
  ClosetPromotionDto,
  ClosetPromotionOrderDto,
  ClosetPromotionMotivationDto,
  PromotedClosetOrderResp,
} from '../types/closet-promotion-order'

export const transformClosetPromotionOrder = (
  dto: ClosetPromotionOrderDto,
): ClosetPromotionOrderModel => ({
  id: dto.id,
  total: transformCurrencyAmountDto(dto.total),
  payable: transformCurrencyAmountDto(dto.payable),
  effectiveDays: dto.effective_days,
  discount: transformCurrencyAmountDto(dto.discount),
  discountPercentage: dto.discount_percentage,
  salesTax: dto.sales_tax ? transformCurrencyAmountDto(dto.sales_tax) : null,
  isTaxCoverageAvailable: dto.tax_coverage_available ?? null,
  isTaxCovered: dto.tax_covered ?? null,
})

export const transformClosetPromotionMotivation = (
  dto: ClosetPromotionMotivationDto,
): ClosetPromotionMotivationModel => ({
  text: dto.text,
  highlight: dto.highlight,
})

export const transformClosetPromotion = (dto: ClosetPromotionDto): ClosetPromotionModel => ({
  closetPromotionOrder: transformClosetPromotionOrder(dto.closet_promotion_order),
  motivation: dto.motivation ? transformClosetPromotionMotivation(dto.motivation) : undefined,
})

export const transformPrepareClosetPromotionOrderResponse = (
  response: Response<PromotedClosetOrderResp>,
) => transformClosetPromotionOrder(response.closet_promotion.closet_promotion_order)
